import { render } from "./CourseSelect.vue?vue&type=template&id=455fb896&scoped=true&ts=true"
import script from "./CourseSelect.vue?vue&type=script&lang=ts"
export * from "./CourseSelect.vue?vue&type=script&lang=ts"

import "./CourseSelect.vue?vue&type=style&index=0&id=455fb896&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455fb896"]])

export default __exports__